// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__UNzCZ","container":"SectionFaq_container__4iC5E","faq__title":"SectionFaq_faq__title__3DDyh","faq__list-container":"SectionFaq_faq__list-container__FUIY7"};